import { render, staticRenderFns } from "./webhook-index.vue?vue&type=template&id=b29c491a"
import script from "./webhook-index.vue?vue&type=script&lang=js"
export * from "./webhook-index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports